import { Set } from 'immutable';

interface IPermissionConfigEntity {
	id: string;
	element: string;
	isGroup: boolean;
	permissions: Set<string>;
	allToggled: boolean;
}

const entityDefaults: IPermissionConfigEntity = {
	id: '-1',
	element: '',
	isGroup: false,
	permissions: Set(),
	allToggled: false,
};

export class PermissionConfigItemEntity implements IPermissionConfigEntity {
	public id = entityDefaults.id;
	public element = entityDefaults.element;
	public isGroup = entityDefaults.isGroup;
	public permissions = entityDefaults.permissions;
	public allToggled = entityDefaults.allToggled;

	public static build(
		params: Partial<IPermissionConfigEntity> = {}
	): PermissionConfigItemEntity {
		const permission = new PermissionConfigItemEntity();
		permission.id = params.id ?? entityDefaults.id;
		permission.element = params.element ?? entityDefaults.element;
		permission.isGroup = params.isGroup ?? entityDefaults.isGroup;
		permission.permissions = params.permissions ?? entityDefaults.permissions;
		permission.allToggled = params.allToggled ?? entityDefaults.allToggled;
		return permission;
	}

	public updatePermissions(permissions: Set<string>): void {
		this.permissions = permissions;
	}

	public updateAllToggled(allToggled: boolean): void {
		this.allToggled = allToggled;
	}
}
